// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"96":"0f4cd0fc","216":"4916994a","250":"fe6d4af3","292":"7993c137","326":"fb3958f8","426":"ffece734","507":"b18b2a03","572":"bc076d3e","631":"81d757d6","688":"f71d46b8","834":"9186b904","873":"2489064d"}[chunkId] + ".chunk.js";
};